/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { DropPointsLeaderboardEntry } from './DropPointsLeaderboardEntry';
import {
    DropPointsLeaderboardEntryFromJSON,
    DropPointsLeaderboardEntryFromJSONTyped,
    DropPointsLeaderboardEntryToJSON,
    DropPointsLeaderboardEntryToJSONTyped,
} from './DropPointsLeaderboardEntry';

/**
 * 
 * @export
 * @interface DropPointsLeaderboardResponse
 */
export interface DropPointsLeaderboardResponse {
    /**
     * 
     * @type {Array<DropPointsLeaderboardEntry>}
     * @memberof DropPointsLeaderboardResponse
     */
    entries: Array<DropPointsLeaderboardEntry>;
    /**
     * 
     * @type {number}
     * @memberof DropPointsLeaderboardResponse
     */
    total: number;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof DropPointsLeaderboardResponse
     */
    paginationInfo: PaginationInfo;
}

/**
 * Check if a given object implements the DropPointsLeaderboardResponse interface.
 */
export function instanceOfDropPointsLeaderboardResponse(value: object): value is DropPointsLeaderboardResponse {
    if (!('entries' in value) || value['entries'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    return true;
}

export function DropPointsLeaderboardResponseFromJSON(json: any): DropPointsLeaderboardResponse {
    return DropPointsLeaderboardResponseFromJSONTyped(json, false);
}

export function DropPointsLeaderboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropPointsLeaderboardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(DropPointsLeaderboardEntryFromJSON)),
        'total': json['total'],
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
    };
}

export function DropPointsLeaderboardResponseToJSON(json: any): DropPointsLeaderboardResponse {
    return DropPointsLeaderboardResponseToJSONTyped(json, false);
}

export function DropPointsLeaderboardResponseToJSONTyped(value?: DropPointsLeaderboardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entries': ((value['entries'] as Array<any>).map(DropPointsLeaderboardEntryToJSON)),
        'total': value['total'],
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
    };
}

